module.exports = __webpack_public_path__ + "static/media/LogoOrange.a9be74c5.png";